import { NgModule } from '@angular/core';
import { ValidationService } from './validation.service';

@NgModule({
  providers: [
    ValidationService
  ]
})
export class FormValidationModule {}
